import React from 'react';

/** Only a product a person confirmed is the garment on screen; the catalog's "Closest match" and a
 *  hand-picked "Similar style" are look-alikes. */
export const isConfirmedMatch = (matchType?: string) => matchType === 'Confirmed match';

/** A small "Similar style" pill next to the brand of anything that is not the exact garment, so the
 *  EadianDree cardigan does not read as Kelly's own (Jason, SIL-1592). One short label instead of the
 *  "Similar style · Cardigans · Light Blue" line (Josh: too much text). */
const MatchBadge: React.FC<{ matchType?: string }> = ({ matchType }) =>
  matchType && !isConfirmedMatch(matchType) ? (
    <span className="inline-flex shrink-0 items-center rounded-full bg-gray-100 px-2 py-0.5 text-[10px] font-medium normal-case tracking-normal text-gray-600">Similar style</span>
  ) : null;

export default MatchBadge;
